<template>
  <v-container class="main-container responsive-height create-investor-account-wrapper">
    <v-row>
      <v-col cols="12">
        <div class="middle-bar">
          <div class="titleName mb-1">
            <v-icon class="mr-2" color="#5F7692">mdi-bag-checked</v-icon>
            <span class="text--ash">Select {{ this.managerType == 'general' ? 'General' : 'Trademaster' }} Manager Firsts</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-skeleton-loader v-if="loading" type="card" class="mt-5" :loading="true" width="400"></v-skeleton-loader>
      <v-col md="6" sm="6" lg="4" v-for="(manager, index) in managerLists" :key="manager.id" v-if="!loading">
        <v-card class="elevation-0 rounded-0 transition-method-card investor-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <div class="ribbon">
            <span>
              <template v-if="managerLists && managerLists.length > 0">
                <template v-if="index === 0"> Rank 1 </template>
                <template v-else-if="index === 1"> Rank 2 </template>
                <template v-else-if="index === 2"> Rank 3 </template>
              </template>
            </span>
          </div>
          <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : 'transparent'">
            <div class="user-profile">
              <div class="profile-image">
                <v-badge avatar bordered overlap color="black accent-4" icon="mdi-star-outline">
                  <v-avatar size="59">
                    <v-img src="../../assets/avatar.png"></v-img>
                  </v-avatar>
                </v-badge>
              </div>
              <div class="profile-text">
                <span style="color: #039de9; font-size: 14px">Manager
                  {{
                    manager.manager_type === 0
                      ? "(MAM)"
                      : manager.manager_type === 1
                        ? "(PAMM)"
                        : manager.manager_type === 2
                          ? "(Copy trade)"
                          : null
                  }}</span>
                <span style="font-size: 14px">{{ manager.st_username || "No Username" }} ({{ manager.trading_account_no || "" }})</span>
              </div>
            </div>
          </v-card>
          <v-card-actions>
            <div class="value">
              <span>Profit (all time)</span>
              <span>{{ manager?.totalProfit < 0 ? 0 : manager?.totalProfit?.toFixed() }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value">
              <span>Age (days)</span>
              <span>{{ manager.age }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="100%" height="95px" type="line" :options="options"
                  :series="manager.totalProfit > 0 ? profitGain : profitLoss"></apexChart>
              </div>
            </v-sheet>
          </v-card-actions>

          <v-card-actions class="pb-0 pt-3">
            <v-btn :to="{
              path: '/manager-details',
              query: {
                id: manager.id,
                type: manager.manager_type,
              },
            }" tile outlined elevation="0" class="text-capitalize btn-account mr-2 ml-n1"
              color="greenMain">Details</v-btn>
            <v-btn :to="{
              path: '/create-investor-account-auth',
              query: {
                id: manager.id,
                type: manager.manager_type,
              },
            }" tile elevation="0" class="text-capitalize btn-account ml-0" color="greenMain">Invest</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="12" sm="12">
        <p class="text-center" v-if="!managerLists?.length && !loading">No Manager Account Found</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    loading:false,
    managerType: null,
    options: {
      chart: {
        type: "line",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
      stroke: {
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#3A648E"],
    },
    profitGain: [
      {
        name: "Profit",
        data: [2, 10, 50, 40, 60, 80, 95],
      },
    ],
    profitLoss: [
      {
        name: "Profit",
        data: [45, 52, 38, 45, 19, 23, 2],
      },
    ],
  }),
  computed: {
    ...mapState("mam", ["managerLists"]),
  },

  methods: {
    ...mapActions("mam", [MAM__ACTIONS.MANAGERLISTS]),
  },

  async mounted() {
    try  {
      this.loading = true;
      await this[MAM__ACTIONS.MANAGERLISTS]({ managerType: this.managerType });
    } catch (error) {
      console.error("Error fetching manager accounts:", error);
    } finally {
      this.loading = false;
    } 
  },

  created(){
    const url = new URLSearchParams(window.location.search);
    this.managerType =  url.get('type');
  }
};
</script>
